export const baseUrl = process.env.REACT_APP_BASE_URL

export const endpoints = {
    login: {
        post: baseUrl + `/api/user/login`
    },
    checkIn: {
        post: baseUrl + `/api/checkIn`
    },
    checkOut: {
        finger: baseUrl + `/api/checkOut`,
        manual: baseUrl + `/api/checkOut/manual`,
    },
    branch: {
        list: baseUrl + `/api/branches`,
        get: baseUrl + `/api/branches/get`,
        post: baseUrl + `/api/branches`,
        delete: baseUrl + `/api/branches`
    },
    lockerType: {
        api: baseUrl + `/api/lockerType`,
    },
    locker: {
        api: baseUrl + `/api/locker`,
        get: ({ id, isMainTable }: { id: number, isMainTable: any }) => baseUrl + `/api/locker/get/${id}?isMainTable=${isMainTable}`,
        add: baseUrl + `/api/locker/add`,
        edit: baseUrl + `/api/locker/update`,
        list: ({ isExport, toDate, fromDate, lockerNo, skip, take, lockerType, lockerLocation, lockerStatus, isMainTable }: { isExport?: boolean, toDate?: string | null, fromDate?: string | null, lockerNo?: any, skip?: number, take?: number, lockerType?: number, lockerLocation?: number, lockerStatus: number | string, isMainTable: string }) => baseUrl + `/api/locker/list?lockerNo=${lockerNo ?? ''}&skip=${skip ?? 0}&take=${take ?? 10}${lockerType ? `&lockerType=${lockerType}` : ''}${lockerLocation ? `&lockerLocation=${lockerLocation}` : ''}${lockerStatus || lockerStatus === 0 ? `&lockerStatus=${lockerStatus}` : ''}&isMainTable=${isMainTable}&isExport=${isExport ?? false}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`,
        approved: ({ lockerId }: { lockerId: number }) => baseUrl + `/api/locker/approved?Id=${lockerId}`,
        bulkApproved: baseUrl + `/api/locker/bulk/approved`,
        import: baseUrl + `/api/UploadLocker`,
        lockerLogs: ({ skip, take, id }: { skip?: number, take?: number, id: any }) => baseUrl + `/api/locker/History/List?id=${id}&skip=${skip}&take=${take}`,
        verify: (lockerId: number, customerId: number) => baseUrl + `/api/customerInformation/VerifyCustomerLocker?LockerId=${lockerId}&CustomerId=${customerId}`,
    },
    lockerLocation: {
        api: baseUrl + `/api/Location`,
        get: ({ id, isMainTable }: { id: number, isMainTable: string }) => baseUrl + `/api/Location/get/${id}?isMainTable=${isMainTable}`,
        list: ({ skip, take, isMainTable }: { skip?: number, take?: number, isMainTable: string }) => baseUrl + `/api/Location/list?isMainTable=${isMainTable}&skip=${skip ?? 0}&take=${take ?? 10}`,
        add: baseUrl + `/api/Location/add`,
        edit: baseUrl + `/api/Location/update`,
        approved: ({ locationId }: { locationId: number }) => baseUrl + `/api/Location/approved?id=${locationId}`,
    },
    lockerVendor: {
        get: baseUrl + `/api/vendor`,
        post: baseUrl + `/api/vendor`,
        delete: baseUrl + `/api/vendor`
    },
    user: {
        get: baseUrl + `/api/user`,
        post: baseUrl + `/api/user`,
        delete: baseUrl + `/api/user`,
    },
    penaltyRate: {
        api: baseUrl + `/api/PenaltyRate`,
        add: baseUrl + `/api/PenaltyRate/add`,
        get: baseUrl + `/api/PenaltyRate/get`,
        active: baseUrl + `/api/PenaltyRate/active`,
        approve: baseUrl + `/api/PenaltyRate/approve`,
        list: ({ skip, take }: { skip?: number, take?: number, }) => baseUrl + `/api/PenaltyRate/List?skip=${skip ?? 0}&take=${take ?? 10}`,
    },
    role: {
        get: baseUrl + `/api/Roles`,
        post: baseUrl + `/api/Roles`,
        delete: baseUrl + `/api/Roles`
    },
    customer: {
        get: baseUrl + `/api/customerInformation`,
        list: (
            { name, mobileNo, accountNo, lockerNo, isMainTable, skip, take, isExport, toDate, fromDate, isReject, isExpired }:
                { isExport?: boolean, toDate?: string | null, fromDate?: string | null, name?: string, mobileNo?: string, accountNo?: string, lockerNo?: string, isMainTable?: string, isReject?: boolean, skip?: number, take?: number, isExpired?: string }
        ) => (
            baseUrl + `/api/customerInformation/List?name=${name ?? ""}&mobileNo=${mobileNo ?? ''}&accountNo=${accountNo ?? ''}&lockerNo=${lockerNo ?? ''}${isMainTable ? `&isMainTable=${isMainTable}` : ''}&isExport=${isExport ?? false}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}&isReject=${isReject ?? false}&skip=${skip ?? 0}&take=${take ?? 10}${isExpired ? `&isExpired=${isExpired}` : ''}`),
        post: baseUrl + `/api/customerInformation`,
        delete: baseUrl + `/api/customerInformation?id=`,
        deactivateJointPoa: baseUrl + `/api/customerInformation/DeactivateJointOrPoa?id=`,
        edit: baseUrl + `/api/customerInformation`,
        api: baseUrl + `/api/customerInformation`,
        activate: baseUrl + `/api/customerInformation/Activate?id=`,
        verify: (id: number) => baseUrl + `/api/customerInformation/VerifyCustomer?id=${id}`,
        reject: baseUrl + `/api/customerInformation/CustomerReject`,
        rejectToApproval: (id: number) => baseUrl + `/api/customerInformation/RejectToNeedToApproved?id=${id}`,
        import: baseUrl + `/api/upload`,
        getCustomerByAccountNo: (accountNo: any) => baseUrl + `/api/customerInformation/CustomerFromCBS/${accountNo}`,
    },
    customerLockers: {
        api: baseUrl + `/api/customerLocker/GetLockerByCustomerId`,
    },
    nomineeInformation: {
        api: baseUrl + `/api/nomineeInformation`
    },
    customerFinger: {
        api: baseUrl + `/api/customerFinger`
    },
    common: {
        getBranches: baseUrl + `/api/common/getBranches`,
        getLockerTypes: baseUrl + `/api/common/getLockerTypes`,
        getLocations: (branchId?: number) => baseUrl + `/api/common/getLocations${branchId ? `?branchId=${branchId}` : ''}`,
        getLockers: baseUrl + `/api/common/getLockers`,
        getLockersByLockerTypeId: (lockerType: any) => baseUrl + `/api/common/getLockersByLockerTypeId?lockerTypeId=${lockerType}`,
        getLockerStatus: baseUrl + `/api/common/GetLockerStatus`,
        getLockerStatusForLockerUpdate: baseUrl + `/api/common/GetLockerStatusForLockerUpdate`,
        getRoles: baseUrl + `/api/common/GetRoles`,
        getVendors: baseUrl + `/api/common/GetVendors`,
        getRentChargeFrequency: baseUrl + `/api/common/GetRentChargeFrequency`,
        getRelationships: baseUrl + `/api/common/GetRelationships`,
        getDesignations: baseUrl + `/api/common/GetDesignations`,
        getDiscountTypes: baseUrl + `/api/common/GetDiscountTypes`,
        getCustomersByLocker: (lockerNo: any) => baseUrl + `/api/common/GetAllCustomerById?lockerNo=${lockerNo}`,
    },
    dashboard: {
        dashInfo: baseUrl + `/api/Dashboard`,
        visitLogs: baseUrl + `/api/Dashboard/GetVisitLogsList`,
    },
    visitLogs: {
        visitCount: baseUrl + `/api/visitLog`,
        ongoing: baseUrl + `/api/visitLog/OngoingVisitList`,
        completed: baseUrl + `/api/visitLog/CompletedVisitList`,
    },
    lockerAccessHistory: {
        api: baseUrl + `/api/LockerAccessHistoryApi`,
        list: ({ lockerNumber, fromDate, toDate, name, location, skip, take, isExport }: { lockerNumber?: any, fromDate?: any, toDate?: any, name?: any, location?: any, skip?: number, take?: number, isExport?: boolean }) => baseUrl + `/api/LockerAccessHistoryApi/List?LockerNumber=${lockerNumber ?? ''}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}&name=${name ?? ''}&location=${location ?? ''}&isExport=${isExport ?? false}&skip=${skip ?? 0}&take=${take ?? 10}`,
    },
    lockerCharge: {
        list: ({ isChargeDeducted, fromDate, toDate, customerName, lockerNo, location, skip, take, isExport, isPenalty, penalOption, renewOption, transationType }: { isChargeDeducted?: boolean | null, fromDate?: any, toDate?: any, customerName?: any, lockerNo?: any, location?: any, skip?: number, take?: number, isExport?: boolean, isPenalty?: any, penalOption?: any, renewOption?: any, transationType?: number }) => baseUrl + `/api/lockercharge/list?${isChargeDeducted ? `isChargeDeducted=${isChargeDeducted}` : ''}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}&customerName=${customerName ?? ''}&lockerNo=${lockerNo ?? ''}${location ? `&location=${location}` : ''}&isExport=${isExport ?? false}&isPenalty=${isPenalty === 'true' ? true : false}&skip=${skip ?? 0}&take=${take ?? 10}${penalOption ? `&PenalOption=${penalOption}` : ''}${renewOption ? `&RenewOption=${renewOption}` : ''}&transationType=${transationType ?? 0}`,
        renew: (lockerId: number, customerId: number) => baseUrl + `/api/lockercharge/DeductIndividualLockerCharge?lockerId=${lockerId}&customerId=${customerId}`,
        deductPenalty: ({ lockerId, customerId, penaltyAmount }: { lockerId: any, customerId: any, penaltyAmount: any }) => baseUrl + `/api/lockercharge/DeductPenalty?lockerId=${lockerId}&customerId=${customerId}&penaltyAmount=${penaltyAmount}`,
        updatePenalty: baseUrl + `/api/lockercharge/UpdatePenalty`,
        renewViaTrigger: baseUrl + `/api/lockercharge/RenewviaTrigger`,
        getTransactionType: baseUrl + `/api/common/GetTransactionType`
    },
    lockerRenewTrigger: {
        renew: baseUrl + `/api/lockerRenew`,
        check: baseUrl + `/api/lockerRenew/list`,
    }
}
